











import { BigNumber } from "@/utils";
import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters("network", ["initialSupply", "supply"]),
  },
})
export default class TotalForged extends Vue {
  private initialSupply: string;
  private supply: number;

  get totalForged() {
    if (!this.initialSupply || !this.supply) {
      return 0;
    }

    return BigNumber.make(this.supply).minus(this.initialSupply).toString();
  }
}
